import React, { useContext, useEffect, useState, } from "react";
import { Container, CTA, IntegratorRoot, MovingFrame, ApplicationRoot, styled, } from "@volkswagen-onehub/components-core";
import { Logout, ExpressService } from "@volkswagen-onehub/icons-core";
import { ServiceContext } from "./context/ServiceContext";
import { signOut } from "@aws-amplify/auth";
import { getVersion } from "./getVersion";
import { ConfigContext } from "./context/ConfigContext";
import { AppConfigLayer } from "./component/AppConfigLayer";
const StyledRoot = styled.div `
  height: 100%;
  min-height: 100vh;
  width: 100%;
`;
const ApplicationContainer = (props) => {
    const { children } = props;
    const layerManager = useContext(ServiceContext).layerManager;
    const { config } = useContext(ConfigContext);
    const [layer, setLayer] = useState(null);
    useEffect(() => {
        layerManager.subscribe(() => {
            setLayer(layerManager.layer);
        });
    });
    const handleLogout = async () => {
        try {
            await signOut({ global: true }).then(() => {
                window.location.href = "/";
            });
        }
        catch (err) {
            console.log("error", err);
        }
    };
    const version = getVersion();
    const env = config?.envName;
    const claim = (React.createElement(CTA, { tag: "a", emphasis: "tertiary", onClick: () => {
            layerManager.openAlert(React.createElement(AppConfigLayer, null));
        } }, `Onehub Manager [Cloud - ${env}] v${version}`));
    return (React.createElement(IntegratorRoot, null,
        React.createElement(ApplicationRoot, null,
            React.createElement(StyledRoot, null,
                React.createElement(Container, { padding: {
                        left: "grid001",
                        right: "grid001",
                        top: "static200",
                    }, horizontalAlign: "flex-end" },
                    React.createElement(Container, { gutter: "static350", padding: "static200", wrap: "never" },
                        React.createElement(CTA, { tag: "button", emphasis: "tertiary", onClick: () => handleLogout(), icon: React.createElement(Logout, null) }, "Logout"))),
                React.createElement(MovingFrame, { claim: claim, logo: React.createElement(CTA, { tag: "button", emphasis: "tertiary", "aria-label": "logon", icon: React.createElement(ExpressService, null) }) }),
                React.createElement(Container, { stretchContent: true, wrap: "always", padding: {
                        top: "static300",
                    }, gutter: "static500" }, children),
                React.createElement("div", null, layer)))));
};
export { ApplicationContainer };
